import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Systems from './pages/Systems';
import Catalog from './pages/Catalog';
import About from './pages/About';
import Contact from './pages/Contact';
import BlogPost from './pages/BlogPost';
import AuditTool from './components/AuditTool';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>AlonForge Solutions | Modern IT Systems & Portfolios PH</title>
        <meta
          name="description"
          content="Custom small-medium systems & UI portfolios for freelancers & businesses—blueprinted for success."
        />
        <meta
          name="keywords"
          content="IT systems Philippines, freelancer portfolios, custom CRM Manila, inventory systems, automation Philippines"
        />
      </Helmet>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/systems" element={<Systems />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/audit" element={<AuditTool />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
